<template>
  <GerenciarPermissoes />
</template>

<script>
import GerenciarPermissoes from '@/components/utils/documentos/DocGerenciarPermissoes.vue'
export default {
  components: {
    GerenciarPermissoes,
  },
}
</script>

<style></style>
